import React from 'react';

const PublicLayout = ({ children }) => <div className="public-layout">{children}</div>;

export default PublicLayout;
